import { combineReducers } from 'redux'

import Service from './Core/UIServiceReducer'
import Form from './Form/UIFormReducer'
import Bootstrap from './UIBootstrapReducer'
import Company from './UICompanyReducer'
import Cookie from './UICookieReducer'
import Dashboard from './UIDashboardReducer'
import Documents from './UIDocumentReducer'
import DynamicPage from './UIDynamicPageReducer'
import File from './UIFileReducer'
import Invite from './UIInviteUserReducer'
import Lead from './UILeadReducer'
import List from './UIListReducer'
import Login from './UILoginReducer'
import Page from './UIPageReducer'
import Post from './UIPostReducer'
import PostType from './UIPostTypeReducer'
import Profile from './UIProfileReducer'
import Property from './UIPropertyReducer'
import Redirection from './UIRederectionReducer'
import Rss from './UIRssReducer'
import SideMenu from './UISideMenuReducer'
import Site from './UISiteReducer'
import Taxonomy from './UITaxonomyReducer'
import User from './UIUserReducer'

export default combineReducers({
  Login,
  Bootstrap,
  SideMenu,
  Post,
  Property,
  Site,
  Profile,
  Documents,
  Taxonomy,
  User,
  Invite,
  Lead,
  List,
  PostType,
  Page,
  DynamicPage,
  Redirection,
  Service,
  Form,
  Company,
  Rss,
  Dashboard,
  Cookie,
  File,
})
